@include media-breakpoint-up(xl) {
    .app-nav {
        display: flex;
        max-height: none !important; //override JS style from mobile
        gap: 2.25rem;

        &__parent {
            a, div {
                position: relative;
                display: block;
                color: #fff;
                @include text-size(18);
                font-weight: 500;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -1px;
                    left: calc(50% + 0.5rem);
                    transform: translateX(-50%);
                    width: 0;
                    height: 3px;
                    background: $secondary;
                    opacity: 0;
                    transition: all 300ms;
                }

                &:is(:hover, :focus-within) {

                    &::after {
                        opacity: 1;
                        width: calc(100% - 0.5rem);
                    }
                }
            }
            &-toggle {
                &:is(:focus-within) {
                    .app-nav__sub {
                        display: flex;
                        animation: subNavIn 200ms linear forwards;
    
                        &.simple-children {
                            display: flex;
                        }
                    }
                }
            }
        }

        &__sub {
            display: none;
            position: absolute;
            top: 100%;
            background: #fff;
			box-shadow: inset -10px 6px 16px rgba(0, 0, 0, 0.15);

            &.mega-children {
                left: 0;
                width: 100%;
                min-height: 280px;

                &.no-break {
                    left: auto;
                    min-width: 250px;
                    width: auto;
                }
            }

            &.simple-children {
                display: none;
                min-width: 250px;
                width: auto;
                min-height: 280px;
				transform: translateX(-70px);

                .simple-children__links {
                    width: 250px;
                    padding: 24px;

                    a {
                        display: flex;
                        align-items: center;
                        color: $primary;
                        @include text-size(16);
                        @include line-height(24);
                        font-family: $font-family-secondary;
                        font-weight: 400;
                        margin-bottom: 12px;
                        text-decoration: none;
        
                        svg {
                            @include svg-format(14px, 14px, $secondary);
                            transform: translateX(5px);
                            transition: all 300ms;
                        }
        
                        &:is(:hover, :focus) {
                            color: $secondary;
                            text-decoration: underline;
							
                            svg {
                                transform: translateX(10px);
                            }
                        }
                    }
                }                
            }
        }

        &__node {
			&:last-of-type {
                position: relative;

				.simple-children {
					transform: translateX(-115px);
				}

                .simple-children {
                    &.has-cta {
                        transform: translateX(-310px);
                    }
                }
			}
            &:nth-of-type(3) {
                .simple-children {
                    &.has-cta {
                        transform: translateX(-100px);
                    }
                }
            }

            &.open {
                .app-nav__parent {
                    a {
                        &::after {
                            opacity: 1;
                            width: calc(100% - 0.5rem);
                        }
                    }
                }
            }

            &:hover {
                .app-nav__parent {
                    a, div {

                        &:after {
                            opacity: 1;
                        }
                    }
                }

            }
            .app-nav__sub {

                &.open {
                    display: flex;
                    animation: subNavIn 200ms linear forwards;
    
                    &.simple-children {
                        display: flex;
                    }
                }
            }

            &:focus-within {
                .app-nav__parent {
                    a, div {
                        background: #fff;
                        color: $primary;

                        &:after {
                            opacity: 1;
                            width: calc(100% - 0.5rem);
                        }
                    }
                }
            }
        }

        &__children {
            padding: 2rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        &__children-mobile {
            display: none;
        }

        &__child {
            margin-bottom: 20px;

            a {
                display: flex;
                align-items: center;
                color: $primary;
                @include text-size(15);
                font-weight: 700;
                text-decoration: none;

                svg {
                    @include svg-format(16px, 16px, $secondary);
                    margin-bottom: 2px;
                    transform: translateX(5px);
                    transition: all 300ms;
                }

                &:hover {
                    color: $tertiary;

                    svg {
                        transform: translateX(10px);
                        circle {
                            fill: $primary !important;
                        }
                        line {
                            stroke: #fff !important;
                        }
                    }
                }
            }
        }

        &__third-level {
            margin: 0 0 1.5rem 1rem;
            
            &:last-child {
                margin-bottom: 0;
            }

            div {
                a {
                    display: inline-block;
                    margin-bottom: 1rem;
                    color: $font-color-primary;
                    text-decoration: none;
                    font-family: $font-family-secondary;
                    @include text-size(16);
                    @include line-height(24);
                    font-weight: 400;

                    svg {
                        @include svg-format(16px, 16px, $secondary);
                        margin-bottom: 2px;
                        transform: translateX(5px);
                        transition: all 300ms;
                    }

                    &:is(:hover, :focus) {
                        text-decoration: underline;
                        color: $secondary;

                        svg {
                            transform: translateX(10px);
                            circle {
                                fill: $primary !important;
                            }
                            line {
                                stroke: #fff !important;
                            }
                        }
                    }
                }
            }
        }

        &__cta {
            height: 100%;
        }
    }

    body.menu-entered .menu-overlay {
        display: block;
        animation: subNavIn 200ms linear forwards;
    }
}

.menu-overlay {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    display: none;
}

.app-nav {
    align-items: center;

    &__cta {
        position: relative;
        width: 287px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-size: cover;
        background-position: center;
    }

    &__cta-content {
        position: relative;
        padding: 30px;
        color: #fff;
        z-index: 2;

        .cta-title {
            @include text-size(20);
            @include line-height(30);
            font-weight: 400;
            color: $white;
            text-align: center;
            font-family: $font-family-secondary;
            margin-bottom: 10px;
        }
        .btn.btn-tertiary__lite {
            margin-bottom: 0;

        }
    }
}

@include media-breakpoint-down(xl) {
    .app-nav {
        background: #fff;
        position: absolute;
        left: 0;
        top: 81px;
        width: calc(100% - 20px);
        margin-top: -2px;
        opacity: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 26px;
        transform: translateX(-105%);
        transition: opacity 300ms, transform 300ms;

        &.open {
            opacity: 1;
            transform: translateX(0);
        }

        &__sub {
            display: none;
        }

        &__parent-toggle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            width: 50px;

            svg {
                @include svg-format(10px, 12px, #333);
                transition: all 350ms;
            }
        }

        &__parent,
        &__child-link {
            display: flex;

            a, div {
                display: block;
                flex-grow: 1;
                @include text-size(16);
                font-weight: 600;
                color: #333;
                text-decoration: none;
                padding: 1rem 0;
                inline-size: min-content;
                user-select: none;
            }
        }

        &__children {
            display: none;
        }

        &__node {

            .app-nav__parent-toggle {
                kdx-icon {
                    &.open {
                        svg {
                            display: block;
                        }
                    }
                    &.close {
                        svg {
                            display: none;
                        }
                    }
                }
            }

            &.open {
                .app-nav__parent {
                    border: none;

                    a {
                        color: $primary;

                        &::after {
                            opacity: 1;
                            width: calc(100% - 0.5rem);
                        }
                    }

                    .app-nav__parent-toggle {
                        background-color: $primary;

                        .open { 
                            margin: auto 0;
                            svg {
                                display: none; 
                            }
                        }
                        .close { 
                            margin: auto 0;
                            svg {
                                display: block; 
                            }
                        }

                        svg {
                            fill: #fff;
                            transform: rotate(180deg);
                        }
                    }
                }

                .app-nav__sub {
                    display: block;
                    border-bottom: 1px solid rgba(54, 69, 79, 0.25);
                }
            }
        }

        &__children-mobile {
            display: block;
            padding: 1rem 0; 
        }

        &__child-link {
            a {
                padding: 9px 18px 8px 0px;
                @include text-size(14);
                @include line-height(22);
                font-family: $font-family-secondary;
                font-weight: 400;
                color: $font-color-primary;
                text-transform: uppercase;
            }

            .app-nav__parent-toggle {
                width: 38px;

                svg {
                    fill: $primary;
                }
            }
        }

        &__child {
            &:first-of-type {
                .app-nav__child-link {
                    border: none;
                }
            }

            &.open {
                .app-nav__child-link {

                    .app-nav__parent-toggle {
                        background: $primary;

                        svg {
                            fill: #fff;
                            transform: rotate(180deg);
                        }
                    }
                }

                .app-nav__third-level {
                    border: none;
                    display: block;
                    padding: 6px 0;
                    a {
                        font-weight: 400;
                    }
                }
            }
        }

        .simple-children {
            padding: 15px;

            a:not(.btn) {
                display: block;
                padding: 9px 18px 8px 0px;
                @include text-size(14);
                @include line-height(22);
                text-decoration: none;
                font-family: $font-family-secondary;
                font-weight: 400;
                color: $font-color-primary;

                svg { display: none; }
            }

            .app-nav__cta {
                padding: 15px 0 0 0;
            }
        }

        &__third-level {
            display: none;
            border: none;
            margin-left: 1rem;

            a {
                padding: 11px 22px;
                display: block;
                @include text-size(15);
                color: $primary;
                text-decoration: none;
            }
        }

        &__cta {
            background-image: none !important;
            width: 100%;
            margin-top: 5px;
            padding: 0 0px 16px 0px;

            &:after {
                display: none;
            }
        }

        &__cta-content {
            background: $gray;
            padding: 8px 14px 0px 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    body.menu-open .menu-overlay {
        display: block;
        animation: subNavIn 200ms linear forwards;
    }
}

@keyframes subNavIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
